import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Notification, NotificationType } from '../../generated/api/kreditportalBackendAPI.schemas';

@Component({
    selector: 'elem-msg-line',
    templateUrl: './messageline.component.html',
    styleUrls: ['./messageline.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MessageLineComponent {

    @Input()
    first: boolean;

    @Input()
    notification: Notification;

    constructor(private readonly router: Router) {
    }

    click(): void {
        if (this.notification.targetURI) {
            this.router.navigate([this.notification.targetURI]);
        }
    }

    // Info-Klasse zurueckgeben, damit das Feld kein Link anzeigt, wenn kein Link vorhanden ist
    infoClass(): string {
        if (!this.notification.targetURI) {
            return 'info';
        }

        return '';
    }

    protected readonly NotificationType = NotificationType;
}

@Component({
    selector: 'elem-msg-line-head',
    templateUrl: './messageline.component.html',
    styleUrls: ['./messageline.component.less', './messageline-small.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MessageLineSmallComponent extends MessageLineComponent {

}

